//--------------------------------------------------------------------------------------------------
//# Imports

import React, { useEffect, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
// To be added back later
// import SmartContractContext from '../../scripts/SmartContractContext';
import Aos from "aos";
import "aos/dist/aos.css";

//import walletButton from '../../image/button_4x1.png';
//import connectWallet from '../../scripts/SmartContractOperator';

import logo from '../../image/logo.webp';

import twitter_icon from '../../image/icons/twitter.webp';
// import linkedin_icon from '../../image/icons/linkedin.webp';
import instagram_icon from '../../image/icons/instagram.webp';
import discord_icon from '../../image/icons/discord.webp';

import early_access_button from '../../image/get-early-access-button.webp';

import './navbar.css';











//--------------------------------------------------------------------------------------------------
//# Variables

const connect_on_load = false;

var mobile = false;
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  console.log("Mobile device detected");
  mobile = true;
};

const delay_gap = 200;


//AppStart
const Navbar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

// To be added back later
// let { user_address, setAddress_Context } = useContext(SmartContractContext);
// let { user_token_ID, setTokenID_Context } = useContext(SmartContractContext);
// let { user_balance, setBalance_Context } = useContext(SmartContractContext);
// let { user_metadata, setMetadata_Context } = useContext(SmartContractContext);
// let { user_avatar_URI, setAvatarURI_Context } = useContext(SmartContractContext);









//--------------------------------------------------------------------------------------------------
//# Functions

  useEffect(() => {
    Aos.init({ duration: 2000 });

    // Reset AOS attributes after animation finishes
    setTimeout(() => {
      const buttons = document.querySelectorAll('.navbarCenterButton, .navbarEarlyAccessButton');
      buttons.forEach(button => {
        button.addEventListener('mouseenter', () => {
          button.style.transform = 'scale(1.15)';
          button.style.transition = 'transform 0.5s ease-in-out';
        });

        button.addEventListener('mousedown', () => {
          button.style.transform = 'scale(1.3)';
          button.style.transition = 'transform 0.05s ease-in-out';
        });
    
        button.addEventListener('mouseleave', () => {
          button.style.transform = 'scale(1.0)';
          button.style.transition = 'transform 0.5s ease-in-out';
        });
      });
    }, 1000);  // Match to AOS duration
  }, []);

  function mouseOver(event) {
    let element = document.getElementById(event.target.id);
    element.style.transform = 'scale(1.20)';
  }

  function mouseLeave(event) {
    let element = document.getElementById(event.target.id);
    element.style.transform = 'scale(1.0)';
  }

  function handleClick(event) {
    let id = event.target.id;

    if (id === "navbarWhitelistSignup" || id === "navbarEarlyAccessButton") {
      window.open(
        "https://evanon.earth/alchmbetasignup-siteref",
        "_blank",
        "noopener noreferrer");
      return;
    };

    const sectionMap = {
      navbarTechnology: "alchmizerOverview",
      navbarRoadmap: "roadmap",
      navbarTeam: "team",
      navbarFAQ: "faq"
    };

    const target_section = sectionMap[id];
    if (!target_section) return;
    if (pathname !== "/") {
      navigate(`/?scrollTo=${target_section}`);
      return;
    };

    scrollToSection(target_section);
  };

  function scrollToSection(className) {
    const elem = document.getElementsByClassName(className)[0];
    if (!elem) return;
    window.scroll({
      behavior: "smooth",
      top: elem.offsetTop,
    });
  };







//--------------------------------------------------------------------------------------------------
//# HTML

return (
  <div className='navbar' id="anchorElement_Navbar">
    <div className='navbarContainer'>
      <div className='navbarLeft'>
        <div id="navbarLogo" className='navbarLogo'>
          <a href={window.location['origin']}>
            <img className="navbarLogoImage" id="navbarLogoImage" src={logo} alt='Home' onMouseOver={mouseOver} onMouseLeave={mouseLeave}
              data-aos="fade-down-right" data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Navbar"/>
          </a>
        </div>
      </div>
      <div className='navbarCenter'>
        <div id='navbarWhitelistSignup' className='navbarCenterButton' onClick={handleClick}
          data-aos="fade-down-right" data-aos-delay={1 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Navbar">
            Whitelist Signup
        </div>
        <div id='navbarTechnology' className='navbarCenterButton' onClick={handleClick}
          data-aos="fade-down-right" data-aos-delay={2 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Navbar">
            Technology
        </div>
        <div id='navbarRoadmap' className='navbarCenterButton' onClick={handleClick}
          data-aos="fade-down" data-aos-delay={3 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Navbar">
            Roadmap
        </div>
        <div id='navbarTeam' className='navbarCenterButton' onClick={handleClick}
          data-aos="fade-down-left" data-aos-delay={4 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Navbar">
            Team
        </div>
        <div id='navbarFAQ' className='navbarCenterButton' onClick={handleClick}
          data-aos="fade-down-left" data-aos-delay={5 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Navbar">
            FAQ
        </div>
        <div className='navbarEarlyAccessContainer'>
          <img id='navbarEarlyAccessButton' className='navbarEarlyAccessButton navbarEarlyAccessCenterButton' src={early_access_button} onMouseOver={mouseOver} onMouseLeave={mouseLeave} onClick={handleClick}
            data-aos="fade-down" data-aos-delay="1000" data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Navbar"/>
        </div>
      </div>
      <div className='navbarRight'>
        <div className='navbarSocialsContainer'>
          <a href='https://achlm.xyz/' target="_blank">
            <img className='navbarIcon discordIcon' id='linkedinIcon' src={discord_icon} onMouseOver={mouseOver} onMouseLeave={mouseLeave}
              data-aos="fade-down-left" data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Navbar"/>
          </a>
          <a href='https://evanon.earth/alchminstagram-alchmref' target="_blank">
            <img className='navbarIcon instagramIcon' id='instagramIcon' src={instagram_icon} onMouseOver={mouseOver} onMouseLeave={mouseLeave}
              data-aos="fade-down" data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Navbar"/>
          </a>
          <a href='https://evanon.earth/alchmx-alchmref' target="_blank">
            <img className='navbarIcon twitterIcon' id='twitterIcon' src={twitter_icon} onMouseOver={mouseOver} onMouseLeave={mouseLeave}
              data-aos="fade-down-right" data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Navbar"/>
          </a>
        </div>
      </div>
    </div>
    <div className='navbarEarlyAccessContainer'>
      <img id='navbarEarlyAccessButton' className='navbarEarlyAccessButton navbarEarlyAccessRightButton' src={early_access_button} onMouseOver={mouseOver} onMouseLeave={mouseLeave}  onClick={handleClick}
        data-aos="fade-left" data-aos-delay="1000" data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_Navbar"/>
    </div>
  </div>
)
}
//AppEnd

export default Navbar